import styled from "styled-components";

interface StyleProps {
  height?: number;
}

export const Styles = styled.div<StyleProps>`
  position: relative;
  height: 100%;
  align-content: center;

  ol {
    padding: 20px;
  }
  ul {
    padding: 20px;
  }

  img {
    max-width: 100%;
  }
  .overlay {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
  }
`;
